import { Routes } from '@angular/router';
import { authMatchGuard } from '@fluxonos/features/user/guards /auth-match-guard';

export const routes: Routes = [
  {
    path: 'user',
    loadChildren: () => import('./features/user/user.routes').then((m) => m.userRoutes)
  },
  {
    path: 'studio',
    loadChildren: () => import('./features/studio/studio.routes').then((m) => m.studioRoutes)
  },
  {
    // standalone customer view — own shell, not part of the studio
    path: 'app',
    loadChildren: () => import('./features/customer-app/customer-app.routes').then((m) => m.customerAppRoutes),
    canMatch: [authMatchGuard]
  },
  {
    path: '**',
    redirectTo: 'user/sign-in'
  }
];
